import {SvgDecoded} from '../model/svg-decoded';

export class ThumbnailUtils {

  //TODO: CHANGE IT WHEN OffscreenCanvasAPI ADMITS SVG RENDERING (web-workers)
  public static buildSvgThumbnail(data: SvgDecoded): Promise<string> {
    const svg: SvgDecoded = data;

    const svgBlob: Blob = new Blob([svg.dataDecoded], {
      type: 'image/svg+xml',
    });
    const svgObjectUrl: string = globalThis.URL.createObjectURL(svgBlob);
    const img: HTMLImageElement = new Image();

    return new Promise((resolve, reject): void => {
      const onImageLoaded = (): void => {
        try {
          const canvasHeight: number = 100;
          const canvasWidth: number = (svg.metaData.width / svg.metaData.height) * canvasHeight;

          const canvas: HTMLCanvasElement = document.createElement('canvas');
          const context: CanvasRenderingContext2D = canvas.getContext('2d');
          if (!context) {
            reject(new Error('Error: no context available'));
            return;
          }

          canvas.width = canvasWidth;
          canvas.height = canvasHeight;

          context.drawImage(img, 0, 0, canvas.width, canvas.height);

          const dataUrl: string = canvas.toDataURL('image/png');

          globalThis.URL.revokeObjectURL(svgObjectUrl);

          resolve(dataUrl);
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = (error: string | Event): void => {
        globalThis.URL.revokeObjectURL(svgObjectUrl);
        reject(new Error('Error loading the SVG'));
      };

      img.addEventListener('load', onImageLoaded);
      img.src = svgObjectUrl;
    });
  }
}

